import { type FC, useMemo } from "react";

import { DialogTrigger as UiDialogTrigger } from "../../Dialog";
import { cn } from "../../utils";
import { type BaseViewHandle } from "../BaseViewHandle";
import { type HydratedRow } from "../useHydratedRows";
import { DialogTriggerCell } from "./DialogTriggerCell";

export const DialogTrigger: FC<{
	row: HydratedRow;
	recordIndex: number;
	viewHandle: BaseViewHandle;
}> = ({ row, recordIndex, viewHandle }) => {
	const topRightColumns = useMemo(() => {
		// `reverse` mutates array, let's copy it to avoid flipping the order every time the
		// component re-renders.
		return [...row.topRightColumns].reverse();
	}, [row.topRightColumns]);

	const hasBottomRightColumns =
		row.bottomLeftColumns.length > 0 || row.bottomRightColumns.length > 0;

	return (
		<div className="relative">
			<div className="absolute top-0 right-0 pt-2 pr-2">
				<div className="flex flex-row gap-2 items-center">
					{topRightColumns.map((cell) => (
						// FIXME: Bad idea for a key.
						<DialogTriggerCell key={cell.header} cell={cell} />
					))}
				</div>
			</div>
			<div className="absolute bottom-0 right-0 pb-2 pr-2">
				<div className="flex space-x-2 items-center mr-2">
					{row.bottomRightColumns.map((cell) => (
						// FIXME: Bad idea for a key.
						<DialogTriggerCell key={cell.header} cell={cell} />
					))}
				</div>
			</div>
			<div className="absolute bottom-0 left-0 pb-2 pl-2">
				<div className="flex space-x-2 items-center mr-2">
					{row.bottomLeftColumns.map((cell) => (
						// FIXME: Bad idea for a key.
						<DialogTriggerCell key={cell.header} cell={cell} />
					))}
				</div>
			</div>

			<UiDialogTrigger asChild onClick={() => viewHandle.openRowDialogAt(recordIndex)}>
				<div className="flex flex-col bg-primary-raised border border-primary shadow-sm hover:border-primary hover:shadow-md rounded-xl text-left cursor-pointer">
					<div className="flex">
						<div
							className={cn("flex flex-col space-y-2 flex-grow p-4", {
								"pb-0": hasBottomRightColumns,
							})}
						>
							{row.primaryDisplayColumn && row.primaryDisplayColumn.visibleOnCard && (
								<DialogTriggerCell
									className="font-bold"
									cell={row.primaryDisplayColumn}
								/>
							)}
							{row.unplacedColumns.map((cell) => {
								return (
									// FIXME: Bad idea for a key.
									<div
										key={cell.header}
										className={cn({ "-ml-2": cell.type !== "Text" })}
									>
										<DialogTriggerCell
											className="text-sm"
											cell={cell}
											disabled={
												!(
													cell.type === "Person" ||
													cell.type === "Select" ||
													cell.type === "Reaction"
												)
											}
										/>
									</div>
								);
							})}
						</div>
					</div>
					{hasBottomRightColumns && <div className="flex items-center h-11">&nbsp;</div>}
				</div>
			</UiDialogTrigger>
		</div>
	);
};
